import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Ipo() {
	return (
		<>
			<div className="beratung_cont" id="market">
				<HelmetProvider>
					<Helmet>
						<title>Beratung bei Börsengänge (IPO)</title>
						<meta name="description" content="Beratung bei Börsengänge (IPO)" />
						<meta
							name="keywords"
							content="Beratung , Börsengänge, IPO, Feingeist, Berlin"
						/>
					</Helmet>
				</HelmetProvider>
				<h1>Beratung bei Börsengänge (IPO)</h1>
				<h2>Wir begleiten Sie auf das Parkett</h2>
				<p>Die Feingeist Beratung begleitet Sie an die Kapitalmärkte.</p>
				<h2>Ihre Vorteile:</h2>
				<ul className="typeset-u-list">
					<li>
						Vollumfängliche Beratung und langfriste Vorbereitung im Vorfeld
					</li>
					<li>Zugang zu Schlüsselinvestoren</li>
					<li>Begleitung bei der Organisation und Roadshow</li>
				</ul>
				<p>
					Gerne begleiten wir Sie bei dem komplexen Vorhaben eines Börsengangs
					zur Aufnahme neuer Aktionäre bzw. zur Kapitalaufnahme oder zur
					Anteilsveräußerung im Rahmen eins Exits.
				</p>
				<p>Sprechen Sie uns an.</p>
			</div>
		</>
	);
}
